"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const modal_1 = __importDefault(require("components/common/modal"));
const form_field_element_1 = __importDefault(require("components/form/form-field-element"));
const React = __importStar(require("react"));
const redux_form_1 = require("redux-form");
require("./household-edit.scss");
class HouseholdCreate extends React.Component {
    onSubmit = (values) => {
        const { closeHouseholdEdit, submitHouseholdForm, id } = this.props;
        // if a user is editing a household name, it will have an id. We want to add
        // that to call so it knows which household to update
        if (id) {
            values.id = id;
        }
        return submitHouseholdForm(values).then(() => {
            return closeHouseholdEdit();
        });
    };
    renderFooter = () => {
        const { closeHouseholdEdit, submitting, id, handleSubmit } = this.props;
        return (React.createElement("div", { className: "u-flex u-flexJustifyEnd u-flexWrapReverse" },
            React.createElement(teamsnap_ui_1.Button, { mods: "cancel u-xs-spaceRightSm", icon: "dismiss", onClick: closeHouseholdEdit }, "Cancel"),
            React.createElement(teamsnap_ui_1.Button, { type: "submit", isDisabled: submitting, color: "primary", icon: submitting ? null : 'check', onClick: handleSubmit(this.onSubmit) },
                submitting && React.createElement(teamsnap_ui_1.Loader, { type: "spin", style: { width: '13px', height: '13px' } }),
                id ? 'Update Household' : 'Create Household')));
    };
    render() {
        const { handleSubmit, closeHouseholdEdit } = this.props;
        return (React.createElement("form", { id: "household", onSubmit: handleSubmit(this.onSubmit), noValidate: true },
            React.createElement(modal_1.default, { hide: closeHouseholdEdit, renderFooter: this.renderFooter, contentLabel: "Create Household" },
                React.createElement("div", { id: "household-create-editor-content" },
                    React.createElement("br", null),
                    React.createElement(redux_form_1.Field, { id: "name", name: "name", component: form_field_element_1.default, type: "text", label: "Household Name", fieldGroupClass: 'Household-name autoFocus' })))));
    }
}
exports.default = (0, redux_form_1.reduxForm)({
    form: 'household',
    enableReinitialize: true, // to load initialValues
})(HouseholdCreate);
